export default __webpack_public_path__ + "static/media/check.c7063b16.JPG";